import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";

import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";

import { default as DefaultCongImg } from "./code-map-cong-img-set-default";
import { default as DaebangCongImg } from "./code-map-cong-img-set-daebang";

const styles = theme => ({
  buttonWrap: {
    marginTop: theme.spacing.unit
  },
  button: {
    margin: theme.spacing.unit
  }
});

@observer
class Cong extends Component {
  //===========================================================================
  @observable open = false;
  @observable imgset = "mro201906290109070001";
  //===========================================================================

  render() {
    const { step } = this.props;
    return (
      <Dialog
        onClose={this.close}
        aria-labelledby="simple-dialog-title"
        open={this.open}
        fullWidth={true}
        maxWidth={false}
      >
        <DialogContent>
          <Grid container>
            <Grid item container xs={12} justify="center">
              <DefaultCongImg
                step={step}
                imgset={this.imgset}
                closeCong={this.closeCong}
              />
              <DaebangCongImg
                step={step}
                imgset={this.imgset}
                closeCong={this.closeCong}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
  //===========================================================================

  @action
  openCong = () => {
    const { authStore } = this.props;
    if (authStore.isExistRole("mro201906290109070000")) {
      this.imgset = "mro201906290109070000";
      switch (this.props.step) {
        case 6:
        case 8:
        case 10:
        case 12:
        case 14:
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
          this.open = true;
          break;
        default:
      }
    } else {
      this.imgset = "mro201906290109070001";
      switch (this.props.step) {
        case 2:
        case 4:
        case 6:
        case 8:
        case 10:
        case 12:
        case 14:
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
          this.open = true;
          break;
        default:
      }
    }
  };
  @action
  closeCong = () => {
    this.open = false;
  };
  //===========================================================================
}

export default withStyles(styles)(Cong);
